import React from 'react'
import { Message } from 'semantic-ui-react'

const ErrorMessage = (props) => (
  <Message negative>
    <Message.Header>{props.title}</Message.Header>
    <p>{props.body}</p>
  </Message>
)

export default ErrorMessage